/* eslint-disable react/no-children-prop */
import useExpandable from 'Hooks/useExpandable';
import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import ExpandableWrapper from '../ExpandableWrapper';
import AddTagButton from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/Tags/components/AddTagButton';
import { Wrapper } from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/Tags/styled';
import { selectDetail, selectDetailTags } from 'store/Contextualization/AssetDetail/selectors';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_TAGS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import TagItems from './components/TagItems';

const TAB = 'general';
const ID = 'tags';

const Tags = () => {
  const intl = useIntl();
  const vulnTags = useSelector(state => selectDetailTags('vulns', state));
  const currentVuln = useSelector((state) => selectDetail('vulns', state));
  const isExpanded = useExpandable(TAB, ID, vulnTags, currentVuln?._id);
  const hasTagsFeature = useSelector((state) => selectAllowedByRole(state, FEATURE_TAGS, PERMISSION_TYPES.READ));

  if (!hasTagsFeature) return null;

  return (
    <ExpandableWrapper defaultValue={ isExpanded } id="tags" title={ intl.formatMessage({ id: 'manage.detail.tab.general.tags' }) } tab={ TAB }>
      <Wrapper>
        <TagItems />
        <AddTagButton entity="vulnAssetDetail" />
      </Wrapper>
    </ExpandableWrapper>
  );
};

export default Tags;
